import { useRef } from "react";

import { STEPS } from "../enums/steps";

import Asset from "./components/Asset";
import Message from "./components/Message";
import ExerciseRegistry from "./components/ExerciseRegistry";
import GroupPicker from "./components/GroupPicker";

import "./styles.scss";

/**
 * The composer body stays minimal: photo, message and (when composing) the
 * workout log. "Who can see" and "when to publish" live in the footer as
 * option buttons with their own panels (see the modal's index).
 */
export default function PublishPostView({
    step,
    selection,
    picker,
    configRef,
    exerciseRegistry,
    onExerciseRegistryChange,
    onUploadBusyChange,
    editing,
}) {
    // Each step mounts in its own keyed wrapper, which slides in from the side
    // it was reached from (forward → from the right, back → from the left).
    // The direction is fixed once per step change so later re-renders within
    // the step never restart the animation.
    const lastStepRef = useRef(step);
    const directionRef = useRef("forward");
    if (lastStepRef.current !== step) {
        directionRef.current = step === STEPS.POST ? "forward" : "back";
        lastStepRef.current = step;
    }

    const stepClassName = `publish-post-step publish-post-step--${directionRef.current}`;

    if (step === STEPS.GROUP) {
        return (
            <div key={step} className={stepClassName}>
                <GroupPicker {...picker} selectedId={selection.group?.id} />
            </div>
        );
    }

    const communityId = selection.community?.id
        ? parseInt(selection.community.id)
        : null;

    return (
        <div key={step} className={`${stepClassName} publish-post-form`}>
            <Asset
                configRef={configRef}
                communityId={communityId}
                onUploadingChange={onUploadBusyChange}
            />
            <Message configRef={configRef} />

            {/* The workout log belongs to the moment of posting; an edit keeps whatever was logged. */}
            {!editing && (
                <ExerciseRegistry
                    configRef={configRef}
                    enabled={exerciseRegistry}
                    onEnabledChange={onExerciseRegistryChange}
                />
            )}
        </div>
    );
}
